module.exports = __webpack_public_path__ + "static_pc/img/banner.8ab94d9f.png";